import './PaidPage.css';

import logoImage from './../../image/logo.svg';
import btnIcon from './../../image/contact-btn-icon.svg';
import btnIconActive from './../../image/active-btn.svg';
import { useEffect } from 'react';

const PaidPage = ({ setCurrentPage, paymentList, loadingCurrentOrder }) => {
    // const handlePaidMethodClick = () => {
    //     setCurrentPage('PaidMethodPage');
    // };

    useEffect(() => {
        loadingCurrentOrder();
    }, []);

    useEffect(() => {
        console.log('paymentList: ', paymentList);
    }, [paymentList]);

    // форматирование прайса
    const formatPrice = (price) => {
        return price.toLocaleString('ru-RU');
    };

    return (
        <div className='paid__wrapper'>
            <div className='paid__logo'>
                <img src={logoImage} alt='Logo' />
            </div>
            {paymentList ? (
                <div className='paid__items'>
                    <div className='paid__check_items'>
                        <div className='paid__check_item'>
                            <ul className='paid__check_list'>
                                <li className='paid__check_position'>
                                    <p className='paid__check_sum'>ИТОГО</p>
                                    <p className='paid__check_price'>
                                        {formatPrice(paymentList.price)}
                                    </p>
                                </li>
                                {paymentList.orderItems.map((position) => (
                                    <li
                                        className='paid__check_position'
                                        key={position.itemId}
                                    >
                                        <p className='paid__check_name'>
                                            {position.name}
                                        </p>
                                        <p className='paid__check_price'>
                                            {formatPrice(position.price)}
                                        </p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* <button className='paid__check_btn'>
                        <p>Применить клубную карту</p>
                        <img src={btnIcon} />
                    </button> */}
                    </div>
                    <div className='paid__btns'>
                        {/* <button
                        className='paid__btn'
                        onClick={handlePaidMethodClick}
                    >
                        Выбрать способ оплаты
                    </button> */}
                        {/* <button className='paid__btn'>Оплатить</button> */}
                        {/* <button className='paid__btn'>Оплатить кухню</button> */}
                        {/* <button className='paid__btn'>Оплатить кальяны</button> */}
                    </div>
                </div>
            ) : (
                <div className='paid__items_add'>
                    Сформируйте заказ / Ожидайте ...
                </div>
            )}
        </div>
    );
};

export default PaidPage;
